import PropTypes from "prop-types";
import styles from "./Button.module.css";

const Button = ({
  buttonType = "contained",
  variant = "primary",
  expand = "block",
  className,
  ...props
}) => {
  return (
    <button
      type="button"
      className={`${styles.button} ${styles[buttonType]} ${styles[variant]} ${
        styles[expand]
      } ${className ?? ""}`}
      {...props}
    />
  );
};

export default Button;

Button.propTypes = {
  buttonType: PropTypes.oneOf(["contained", "outlined", "text", "toggle"]),
  variant: PropTypes.oneOf(["primary", "secondary", "danger"]),
  expand: PropTypes.oneOf(["full", "block"]),
};
